import React from "react";
import { context } from './AppContext';
import { Button, Modal, Form, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import Locale from '../locale/Locale';

class LoginWindow extends React.Component {
    state = { realm: 'Prod' }

    render() { 
        return ( 
            <Modal.Dialog style={ this.props.style }>
                <Modal.Body>
                    <Form noValidate onSubmit={ (event) => { 
                        event.preventDefault();
                        this.props.onSubmit(this.state);
                    }}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>{ Locale.gettext("Email") }</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" onChange={ (event) => { this.setState({ email: event.target.value }) }} />
                        </Form.Group> 
                        <Form.Group controlId="formBasicPassword" style={ { marginTop: 20 } }>
                            <Form.Label>{ Locale.gettext("Password") }</Form.Label>
                            <Form.Control type="password" placeholder="Password" onChange={ (event) => { this.setState({ password: event.target.value }) }} />
                        </Form.Group>
                        <Form.Group controlId="formBasicOtp" style={{ display: this.props.otpRequired ? 'block' : 'none',marginTop: 20 }}>
                            <Form.Label>{ Locale.gettext("One-Time Password / Token Code") }</Form.Label>
                            <Form.Control type="text" placeholder="OTP" onChange={ (event) => { this.setState({ otp: event.target.value }) }} />
                        </Form.Group>
                        <Button variant="primary" type="submit" style={ { marginTop: 20 } }>Login</Button>
                    </Form>
                </Modal.Body>
            </Modal.Dialog>
         );
    }
}
 
export default LoginWindow;